import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[900px]">
        <SectionHeading
          eyebrow="FAQ"
          title="关于韩国漫画榜单的常见问题"
          desc="入坑前你可能想先弄清楚这几件事，看完再决定从哪部开始。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? "" : item.id)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <i className="ri-question-line text-lg text-primary-500" />
                    <span className="font-heading text-base font-semibold text-foreground-950">{item.q}</span>
                  </span>
                  <i
                    className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[52px] text-sm leading-relaxed text-foreground-600">{item.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}